export { useGranter as default } from '@portal-internet/core';